import { styled } from '@mui/material/styles'
import { Box, Button, Typography, TextField } from '@mui/material'

export const StyledContainer = styled(Box)({
  padding: '24px',
  color: 'white',
  backgroundColor: '#0d0d0d',
})

export const PostContainer = styled(Box)({
  backgroundColor: '#000000',
  borderRadius: '24px',
  padding: '32px',
  maxWidth: '1000px',
  margin: '0 auto',
  display: 'grid',
  gridTemplateColumns: '400px 1fr',
  gap: '48px',
  '@media (max-width: 1200px)': {
    gridTemplateColumns: '1fr',
  },
})

export const MediaSection = styled(Box)({
  position: 'relative',
  borderRadius: '24px',
  overflow: 'hidden',
  aspectRatio: '1/1',
  boxShadow: '4px 8px 20px 0px #FFFFFF40',
  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
})

export const PlayButton = styled(Box)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '64px',
  height: '64px',
  backgroundColor: 'rgba(255, 255, 255, 0.9)',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  '& svg': {
    fontSize: '32px',
    color: '#4B4DED',
  },
})

export const ContentSection = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
})

export const CategoryTags = styled(Box)({
  display: 'flex',
  gap: '12px',
  marginBottom: '32px',
})

export const CategoryTag = styled(Button)({
  backgroundColor: '#251E0F',
  height: 'fit-content',
  color: '#FEB820',
  padding: '3px 26px',
  borderRadius: '14.5px',
  fontSize: '13px',
  fontWeight: 700,
  letterSpacing: '1.63px',
  textTransform: 'uppercase',
  minWidth: 'unset',
  '&:hover': {
    backgroundColor: '#251E0F',
  },
  '&.youtube-tag': {
    padding: '6px 12px',
    '& img': {
      width: '16px',
      height: '16px',
    },
  },
})

export const HashtagText = styled(Typography)({
  color: '#00D1FF',
  fontSize: '13px',
  fontWeight: 700,
  letterSpacing: '1.63px',
  backgroundColor: '#001317',
  padding: '3px 26px',
  borderRadius: '13px',
  width: 'fit-content',
})

export const PostText = styled(Typography)({
  color: '#959595',
  fontSize: '15px',
  lineHeight: '18px',
  marginBottom: '32px',
  fontWeight: '400',
  letterSpacing: '-0.1px',
  fontFamily: 'Albert Sans',
})

export const BoldSpan = styled('span')({
  fontWeight: 700,
})

export const CommentSection = styled(Box)({
  display: 'flex',
  gap: '20px',
  marginBottom: '48px',
  flexDirection: 'column',
})

export const CommentInput = styled(TextField)({
  width: '100%',
  '& .MuiInputBase-root': {
    backgroundColor: '#171717',
    borderRadius: '12px',
    padding: '16px',
    color: '#cbcbcb',
    fontSize: '15px',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
})

export const ReplyButton = styled(Button)({
  display: 'flex',
  justifyContent: 'end',
  backgroundColor: '#0d0d0d',
  color: '#FFFFFF',
  borderRadius: '20px',
  padding: '4px 24px',
  fontSize: '13px',
  fontWeight: 500,
  textTransform: 'uppercase',
  '&:hover': {
    backgroundColor: '#0d0d0d',
  },
  '& .arrow': {
    marginLeft: '8px',
    display: 'inline-block',
    transform: 'translateY(1px)',
  },
  width: 'fit-content',
})

export const ProfileName = styled(Typography)({
  color: '#FFFFFF',
  fontSize: '14px',
  fontWeight: 500,
})

export const StatsPostContainer = styled(Box)({
  backgroundColor: '#000000',
  borderRadius: '24px',
  padding: '32px',
  maxWidth: '1000px',
  margin: '24px auto',
  display: 'flex',
  gap: '80px',
})

export const ProfileSection = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
})

export const ProfileImage = styled('img')({
  width: '56px',
  height: '56px',
  borderRadius: '50%',
})

export const ProfileInfo = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
})

export const ProfileHandle = styled(Typography)({
  color: '#FFFFFF',
  fontSize: '20px',
  fontWeight: 500,
})

export const ProfilePlatform = styled(Typography)({
  color: 'rgba(255, 255, 255, 0.6)',
  fontSize: '12px',
})

export const ProfileBio = styled(Typography)({
  color: 'rgba(255, 255, 255, 0.6)',
  fontSize: '14px',
})

export const StatsSection = styled(Box)({
  display: 'flex',
  gap: '48px',
})

export const StatColumn = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '8px',
})

export const StatLabel = styled(Typography)({
  color: '#FFFFFF',
  fontSize: '20px',
  fontWeight: 400,
  letterSpacing: '1px',
  textTransform: 'uppercase',
})

export const StatValue = styled(Typography)({
  color: '#bfbfbf',
  fontSize: '32px',
  fontWeight: 700,
  border: '1px solid #292929',
  padding: '20px 35px',
  borderRadius: '20px',
})

export const OtherBox = styled(Box)({
  fontFamily: 'Inter',
  fontWeight: '400',
  fontSize: '36px',
  lineHeight: '16px',
  letterSpacing: '-0.5px',
  textAlign: 'center',
})

export const OtherPostsTitle = styled(Typography)({
  color: '#FFFFFF',
  fontSize: '24px',
  fontWeight: 500,
  textAlign: 'center',
  marginBottom: '32px',
})

export const PostsGrid = styled(Box)({
  columnCount: 3,
  columnGap: '66px',
  margin: '0 auto',
  width: 'fit-content',
  '@media (max-width: 1476px)': {
    columnCount: 2,
  },
  '@media (max-width: 1068px)': {
    columnCount: 1,
  },
})

export const CardWrapper = styled(Box)({
  width: '349px',
  breakInside: 'avoid',
  pageBreakInside: 'avoid',
  marginBottom: '66px',
})

export const PostCard = styled(Box)({
  backgroundColor: '#FFFFFF',
  borderRadius: '24px',
  marginBottom: '24px',
  breakInside: 'avoid',
  pageBreakInside: 'avoid',
  position: 'relative',
  overflow: 'hidden',
  display: 'inline-block',
  width: '100%',
})

export const PostCardHeader = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  padding: '16px',
  position: 'absolute',
  top: 0,
  width: '100%',
  zIndex: 1,
  backgroundColor: 'rgba(255,255,255,0.9)',
  height: '65px',
})

export const CategoryWrapper = styled(Box)({
  display: 'flex',
  gap: '15px',
})

export const PostCategory = styled(Typography)({
  color: '#FEB820',
  background: '#f9f1e1',
  padding: '6px 11px',
  borderRadius: '14.5px',
  fontFamily: 'Alexandria',
  fontWeight: 400,
  fontSize: '13px',
  lineHeight: '15.85px',
  letterSpacing: '1.63px',
  textAlign: 'center',
  textTransform: 'uppercase',
  height: 'fit-content',
})

export const PlatformIcon = styled('img')({
  width: '37px',
  height: '37px',
})

export const PostImage = styled(Box)({
  position: 'relative',
  width: '100%',
  '& img': {
    width: '100%',
    height: 'auto',
    display: 'block',
  },
})

export const PlayOverlay = styled(Box)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '48px',
  height: '48px',
  backgroundColor: 'rgba(255, 255, 255, 0.9)',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

export const PostContent = styled(Box)({
  padding: '16px',
  '&.isVedioPost': {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1,
    backgroundColor: 'rgba(255,255,255,0.9)',
  },
})

export const HashTag = styled(Typography)({
  color: '#00D1FF',
  fontSize: '13px',
  fontWeight: 700,
  marginBottom: '8px',
  background: '#e5f9fc',
  padding: '3px 24px',
  borderRadius: '20px',
  width: 'fit-content',
  letterSpacing: '1.63px',
})

export const PostDescription = styled(Typography)({
  color: '#5c606c',
  fontSize: '15px',
  lineHeight: 1.5,
  marginBottom: '16px',
  letterSpacing: '1.63px',
})

export const ReplyButtonWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
})

export const PostReplyButton = styled(Button)({
  backgroundColor: '#000000',
  color: '#FFFFFF',
  borderRadius: '20px',
  padding: '6px 16px',
  fontSize: '13px',
  textTransform: 'uppercase',
  '&:hover': {
    backgroundColor: '#333333',
  },
  '& .arrow': {
    marginLeft: '8px',
  },
})
